import script from "./SearchForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchForm.vue?vue&type=script&setup=true&lang=ts"

import "./SearchForm.vue?vue&type=style&index=0&id=83120568&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83120568"]])

export default __exports__